import { filter } from 'lodash';
import { searchEntities } from '../../store/selectors/search';

export const selectSuites = state => searchEntities(state, 'suites', ['number', 'firstName', 'lastName', 'email']);

export const selectSuiteById = (state, id) => filter(selectSuites(state), suite => suite.id === id)[0];